module.exports = "/assets/data/f49d3d6f5fa80383b051eff34e0d4103-G63.data.json";